<template>
  <el-timeline v-if="invoice && invoice.lineItems.length" style="padding: 0">
    <el-timeline-item :key="index" v-for="(activity, index) in [...invoice.lineItems].reverse()"
      :timestamp="$options.filters.formatDate(activity.createdAt)" hide-timestamp placement="top"
      :icon="activity.voided ? 'el-icon-warning' : ''"
      :type="activity.type === 'DEBIT' ? 'success' : activity.voided ? 'danger' : 'primary'"
      :color="getLineItemColor(activity)">
      <el-card shadow="never" :body-style="{ background: lineItemBackgroundColor(activity), padding: '1px' }">
        <div class="rs-line-item">
          <div class="descriptions">
            <div class="description">
              <span class="label">Description: </span>
              <span v-if="activity.description">
                {{ activity.description }}
              </span>
              <el-tag size="small" v-if="activity.chargeType === 'FEES' && activity.feeType">
                {{ activity.feeType === 'Security' ? facilitySecurityFeeLabel : activity.feeType }}
              </el-tag>
            </div>
            <div style="justify-content: right" class="description tags-wrapper">
              <el-tag>{{ activity.createdAt | formatDate }}</el-tag>
              <el-tooltip v-if="activity.voided" placement="top" effect="light">
                <template slot="content" v-if="activity.voidedBy">
                  <span style="font-size: 0.85rem; font-family: sans-serif">Voided by {{ activity.voidedBy }}</span>
                </template>
                <el-tag effect="dark" type="danger">
                  VOIDED
                </el-tag>
              </el-tooltip>
              <el-tooltip v-if="activity.custom" placement="top" effect="light">
                <template slot="content">
                  <span v-if="activity.addedBy" style="font-size: 0.85rem; font-family: sans-serif">Added by {{ activity.addedBy }}</span>
                  <span v-else style="font-size: 0.85rem; font-family: sans-serif">No info.</span>
                </template>
                <el-tag effect="dark" type="warning">
                  MANUAL
                </el-tag>
              </el-tooltip>
              <el-tag v-if="activity.refunded" effect="dark" type="danger">REFUNDED</el-tag>
              <el-tag v-if="activity.details === 'RENT'" effect="dark" hit color="#009aca">RENT</el-tag>
              <el-tag v-if="activity.details === 'TAX'" effect="dark" hit color="#159895">TAX</el-tag>
              <el-tag v-if="activity.details === 'FEES'" effect="dark" hit color="#1A5F7A">FEES</el-tag>
              <el-tag v-if="activity.details === 'DEPOSIT'" effect="dark" hit color="#002B5B">SECURITY DEPOSIT</el-tag>
              <el-tag v-if="activity.type === 'DEBIT' && activity.transactionType !== 'ADJUSTMENT' && !activity.refunded"
                effect="dark" type="success">PAYMENT</el-tag>
              <el-tag v-if="activity.type === 'DEBIT' && activity.transactionType === 'ADJUSTMENT'" effect="dark"
                type="warning">ADJUSTMENT</el-tag>
              <el-dropdown v-if="hasVoidAction && activity.type !== 'DEBIT' && !invoice.future && !activity.voided"
                @command="(command) => handleCommandForLineItem(command, activity)">
                <el-button size="small" icon="el-icon-more" :disabled="activity.details === 'TAX'" circle></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :disabled="activity.voided"
                    command="void"
                    v-if="(customer && customer.taxExempted === true) || activity.details !== 'TAX'"
                  >Void</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="descriptions">
            <div class="description">
              <span class="label">Amount: </span>
              <span v-if="activity.amount">
                {{ activity.amount | currencySign($root.state.facilityData) }}
              </span>
              <span v-else>
                {{ Number(0).toFixed(2) | currencySign($root.state.facilityData) }}
              </span>
            </div>
            <div class="description">
              <span class="label">Account Balance: </span>
              <span v-if="activity.accountBalance >= 0 || activity.accountBalance <= 0">
                {{ Number(activity.accountBalance).toFixed(2) | currencySign($root.state.facilityData) }}
              </span>
            </div>
            <div class="description">
              <span class="label">Period: </span>
              <span v-if="activity.period">
                {{ getMonthValue(activity.period) }}
              </span>
            </div>
            <div class="description">
              <span class="label">Due Date: </span>
              <span v-if="activity.dueDate">
                {{ activity.dueDate | formatDate }}
              </span>
            </div>
          </div>
        </div>
      </el-card>
    </el-timeline-item>
  </el-timeline>
</template>

<script>
const lineItemColorMap = {
  VOID: '#ff5e62',
  RENT: '#009aca',
  TAX: '#159895',
  FEES: '#1a5f7a',
  DEPOSIT: '#002b5b',
};

export default {
  name: 'CustomerLeaseLineItems',
  props: {
    invoice: { type: Object, default: () => ({}) },
    customer: { type: Object, default: () => ({}) },
    handleCommandForLineItem: { type: Function, default: () => {} },
    lineItemBackgroundColor: { type: Function, default: () => {} },
    getMonthValue: { type: Function, default: () => {} },
    hasVoidAction: { type: Boolean, default: () => true },
    facilitySecurityFeeLabel: { type: String, default: '' }
  },
  methods: {
    getLineItemColor(activity) {
      const mapKey = activity.voided ? 'VOID' : activity.details;
      return lineItemColorMap[mapKey];
    },
  },
};
</script>

<style>
.rs-line-item {
  background-color: #ffffffe5;
  border-radius: 0.125rem;
  padding: 0.5rem 0.75rem;
}
.descriptions {
  display: flex;
  align-content: space-between;
  flex-wrap: wrap;
}
.description {
  display: flex;
  align-items: center;
  flex-grow: 1;
  font-family: sans-serif;
  align-self: stretch;
  padding: 0.25rem 0.5rem 0.5rem 0.5rem;
}
.description .label {
  font-weight: bold;
  margin-right: 0.5rem;
}
.tags-wrapper {
  display: flex;
  flex-direction: row;
  gap: 0 0.25rem;
  padding-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomerLeaseLineItems.vue